import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../config/api";
import {
    Typography,
    Card,
    Button,
    Space
} from "antd";
import { Helmet } from "react-helmet-async";
import { Inquiries } from "../Offer/InquiriesPage";
import { isLogged } from "../../helpers/account";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const MarketplaceInquiriesPage = () => {
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t('marketplace.inquiries.title')} - Taskizy</title>
            </Helmet>

            <div style={{ background: "#f8f9fa", minHeight: "100vh", padding: "40px 20px" }}>
                <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                    {/* Header */}
                    <div style={{ marginBottom: "32px" }}>
                        <Title level={2} style={{ margin: 0, color: "#2c3e50" }}>
                            {t('marketplace.inquiries.header')}
                        </Title>
                        <Text style={{ color: "#6c757d", fontSize: "16px" }}>
                            {t('marketplace.inquiries.subtitle')}
                        </Text>
                    </div>

                    {/* Marketplace Content */}

                    <Inquiries limit={isLogged() ? 100 : 5} paginationLimit={isLogged() ? 100 : 5} />


                    {/* Login CTA for non-logged users */}
                    {!isLogged() && (
                        <Card
                            style={{
                                border: "none",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                                borderRadius: "12px",
                                marginTop: "24px",
                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "white"
                            }}
                            bodyStyle={{ padding: "40px 24px", textAlign: "center" }}
                        >
                            <Space direction="vertical" size="large" style={{ width: "100%" }}>
                                <div style={{ fontSize: "clamp(60px, 12vw, 80px)", lineHeight: "1", padding: "20px 0" }}>
                                    🚀
                                </div>
                                <Title level={3} style={{ color: "white", margin: 0 }}>
                                    {t('marketplace.inquiries.seeMoreTasks')}
                                </Title>
                                <Text style={{ color: "rgba(255,255,255,0.9)", fontSize: "16px" }}>
                                    {t('marketplace.inquiries.loginPrompt')}
                                </Text>
                                <Link to="/transactions">
                                    <Button
                                        type="primary"
                                        size="large"
                                        style={{
                                            background: "white",
                                            borderColor: "white",
                                            color: "#667eea",
                                            fontWeight: "500",
                                            height: "48px",
                                            padding: "0 32px"
                                        }}
                                    >
                                        {t('nav.login')}
                                    </Button>
                                </Link>
                            </Space>
                        </Card>
                    )}
                </div>
            </div>
        </>
    );
};

export default MarketplaceInquiriesPage;